/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import CustomButton from '../CustomElements/CustomButton';
import { useEffect, useState } from 'react';

/**
 * Компонент отображает панель кнопок для выбора рассылки.
 * Каждая кнопка соответствует одной из рассылок, полученных из Redux-хранилища.
 * При нажатии на кнопку ID выбранной рассылки сохраняется стейт.
 *
 * @param {Object} props - Пропсы компонента.
 * @param {Function} props.setSelectedMailingId - Функция для установки выбранного ID рассылки в родительский компонент.
 *
 * @returns {JSX.Element} Блок с кнопками рассылок.
 */

function ButtonsPanelInBlock({ setSelectedMailingId, t }) {
  const [selectedMailingName, setSelectedMailingName] = useState(''); // Локальное имя выбранной рассылки для подсветки кнопки

  // Получаем список всех рассылок из Redux-хранилища
  const mailings = useSelector((state) => state.adminData.mailings || []);

  // Если рассылка выбрана, сохраняем её ID во внешний стейт через setSelectedMailingId
  useEffect(() => {
    if (selectedMailingName) {
      const selected = mailings.find((m) => m.name === selectedMailingName);
      if (selected?.id) {
        setSelectedMailingId(selected.keyName);
      }
    }
  }, [selectedMailingName]);

  // Если ещё ничего не выбрано, по умолчанию выбираем первую рассылку
  useEffect(() => {
    if (mailings.length && !selectedMailingName) {
      const firstMailing = mailings[0];
      setSelectedMailingName(firstMailing.name);
      setSelectedMailingId(firstMailing.keyName);
    }
  }, [mailings]);

return (
  <div className="adding-data-block__mailings">
    {mailings.length > 0 ? (
      mailings.map((mailing) => (
        <CustomButton
          key={mailing.keyName}
          className={`device_button device_button__mailings ${selectedMailingName === mailing.name ? 'activeBtn' : ''}`}
          width="94%"
          text={mailing.name}
          colorText={'var(--sadr-text-color)'}
          onClick={() => setSelectedMailingName(mailing.name)}
        />
      ))
    ) : (
      <p className="table-no-data">{t?.noMailings || 'Нет доступных рассылок'}</p>
    )}
  </div>
);
}

export default ButtonsPanelInBlock;
